var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { classMap, Component, CustomElement, Event, html, nothing, Prop } from '@sick-davinci/ce-decorators';
import { style } from './FlyoutMenuItem.style';
import { Icon } from '../../icon/Icon';
export
/**
 * A `davinci-flyout-menu-item` displays an item in a `davinci-flyout-menu` and handles slotted subitems as "sub-menu".
 *
 * @example
 * ```html
 * <davinci-flyout-menu-item label="a menu-item with submenu" left>
 *  <davinci-flyout-menu-item label="settings"></davinci-flyout-menu-item>
 *  <davinci-flyout-menu-item label="language"></davinci-flyout-menu-item>
 *  <davinci-flyout-menu-item label="user"></davinci-flyout-menu-item>
 * </davinci-flyout-menu-item>
 * ```
 * @slot {davinci-flyout-menu-item[]} list of sub menus
 */
let FlyoutMenuItem = (_dec = Component({
  tag: 'davinci-flyout-menu-item',
  style,
  // tslint:disable-line:no-unsafe-any
  dependencies: [Icon]
}), _dec2 = Prop({
  type: Boolean
}), _dec3 = Reflect.metadata("design:type", Boolean), _dec4 = Prop({
  type: String
}), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop({
  type: String
}), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop({
  type: Boolean
}), _dec11 = Reflect.metadata("design:type", Boolean), _dec12 = Prop({
  type: Boolean
}), _dec13 = Reflect.metadata("design:type", Boolean), _dec14 = Prop({
  type: Boolean,
  reflectAsAttribute: false
}), _dec15 = Reflect.metadata("design:type", Boolean), _dec16 = Prop({
  type: Boolean,
  reflectAsAttribute: false
}), _dec17 = Reflect.metadata("design:type", Boolean), _dec18 = Event({
  name: 'menu-click'
}), _dec19 = Reflect.metadata("design:type", Object), _dec(_class = (_class2 = class FlyoutMenuItem extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "disabled", _descriptor, this);

    _initializerDefineProperty(this, "icon", _descriptor2, this);

    _initializerDefineProperty(this, "iconSrc", _descriptor3, this);

    _initializerDefineProperty(this, "label", _descriptor4, this);

    _initializerDefineProperty(this, "left", _descriptor5, this);

    _initializerDefineProperty(this, "open", _descriptor6, this);

    _initializerDefineProperty(this, "iconPlaceholder", _descriptor7, this);

    _initializerDefineProperty(this, "submenuPlaceholder", _descriptor8, this);

    _initializerDefineProperty(this, "menuClickEvent", _descriptor9, this);

    _defineProperty(this, "onSlotChange", _event => {
      this.configureSubItems();
    });
  }

  render() {
    const classes = {
      'item-container': true,
      'disabled': this.disabled
    };
    return html`
    <div class="${classMap(classes)}" @click="${this.onItemClicked}">
      <div class="hover-box">
        ${[this.renderIcon(), this.renderLabel(), this.renderSubmenuIndicator()]}
      </div>
      ${this.renderSubMenu()}
    </div>
    `;
  }

  renderIcon() {
    const classes = classMap({
      'item-icon': true,
      'icon-only': !this.label
    });

    if (this.iconSrc) {
      return html`<davinci-icon-ref class="${classes}" src="${this.iconSrc}"></davinci-icon-ref>`;
    } else if (this.iconPlaceholder || this.icon) {
      return html`<davinci-icon class="${classes}" icon="${this.icon}"></davinci-icon>`;
    } else {
      return nothing;
    }
  }

  renderLabel() {
    return this.label ? html`<span class="label">${this.label}</span>` : '';
  }

  renderSubmenuIndicator() {
    const icon = this.children.length ? 'navigation/chevron_right' : '';
    const classes = {
      'submenu-indicator': true,
      'collapse': !(this.submenuPlaceholder || this.children.length)
    }; // unconditional rendering of the .submenu-indicator fixes hover-issue in Edge-Browser

    return html`<span class="${classMap(classes)}"><davinci-icon icon="${icon}"></davinci-icon></span>`;
  }

  renderSubMenu() {
    return this.open ? html`<div class="item-list"><slot @slotchange="${this.onSlotChange}"></slot></div>` : nothing;
  }

  onItemClicked(event) {
    event.stopPropagation();

    if (this.disabled) {
      return null;
    }

    const hasSubmenu = this.children.length > 0;

    if (hasSubmenu) {
      const open = this.open;
      this.closeSubmenuesRecursively(this.parentElement);
      this.open = !open;
    } else {
      this.menuClickEvent.emit(this);
    }

    return this.open;
  }

  configureSubItems() {
    let setSubmenu = false;
    let setIcon = false;
    const subItems = [];

    for (const item of this.children) {
      if (item.tagName === 'DAVINCI-FLYOUT-MENU-ITEM') {
        const menuItem = item;
        subItems.push(item);
        setIcon = setIcon || !!menuItem.icon || !!menuItem.iconSrc || !!menuItem.iconPlaceholder;
        setSubmenu = setSubmenu || !!menuItem.submenuPlaceholder || menuItem.children.length > 0;
      } else {
        window.console.warn('Removed element, because it is no DAVINCI-FLYOUT-MENU-ITEM:', item);
        item.parentElement.removeChild(item);
      }
    }

    for (const item of subItems) {
      item.iconPlaceholder = setIcon;
      item.submenuPlaceholder = setSubmenu;
      item.left = this.left;
    }
  }

  closeSubmenuesRecursively(item) {
    for (const node of item.children) {
      node.open = false;
      this.closeSubmenuesRecursively(node);
    }
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "icon", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "iconSrc", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "left", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "open", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "iconPlaceholder", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "submenuPlaceholder", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "menuClickEvent", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
